// تبدیل ارقام فارسی/عربی و جداکننده‌ها به شکل لاتین/جاواسکریپتی
export function persianToEnglishDigits(str) {
    if (str == null) return str;
    // نگه داشتن به صورت رشته
    str = String(str);
  
    // جایگزین کردن ارقام فارسی (۰–۹) و عربی-ایندیک (٠–٩)
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    const arabicDigits  = '٠١٢٣٤٥٦٧٨٩';
    str = str.replace(/[۰-۹]/g, d => persianDigits.indexOf(d).toString());
    str = str.replace(/[٠-٩]/g, d => arabicDigits.indexOf(d).toString());
  
    // نرمالایز جداکنندهٔ اعشار و حذف جداکنندهٔ هزارگان/ویرگول‌های محلی
    // بعضی جداکننده‌ها: '٫' (U+066B) -> decimal, '٬' (U+066C) -> thousands, '،' (U+060C) -> Persian comma
    str = str.replace(/[\u066B]/g, '.');   // arabic decimal separator -> .
    str = str.replace(/[\u066C\u060C,٬]/g, ''); // حذف هزارگان یا کاماهای محلی و معمولی
  
    // حالا رشتهٔ حاوی فقط ارقام لاتین و احتمالاً '.' است
    return str;
  }
  